import { render, staticRenderFns } from "./detail_pc.vue?vue&type=template&id=1e1a57a9&scoped=true&"
import script from "./detail_pc.vue?vue&type=script&lang=js&"
export * from "./detail_pc.vue?vue&type=script&lang=js&"
import style0 from "./detail_pc.vue?vue&type=style&index=0&id=1e1a57a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1a57a9",
  null
  
)

export default component.exports